import React from 'react';
import { useLocation } from 'react-router-dom';

const Sidebar = () => {
    const location = useLocation();
    const url = location.pathname;

    const handleLinkClick = (to: string) => {
        window.location.href = to;
    };

    return (
        <aside id="sidebar" className="sidebar">
            <ul className="sidebar-nav" id="sidebar-nav">
                <li className="nav-heading">Administration</li>
                <li className="nav-item" style={{cursor: 'pointer'}}>
                    <span
                        className={`nav-link ${url === '/dashboard' ? '' : 'collapsed'}`}
                        onClick={() => handleLinkClick('/dashboard')}
                    >
                        <i className="bi bi-dash-circle"/>
                        <span>Dashboard</span>
                    </span>
                </li>
                <li className="nav-item" style={{cursor: 'pointer'}}>
                    <span
                        className={`nav-link ${url === '/create-blog' ? '' : 'collapsed'}`}
                        onClick={() => handleLinkClick('/create-blog')}
                    >
                        <i className="bi bi-grid"/>
                        <span>Create New Blog</span>
                    </span>
                </li>
                <li className="nav-item" style={{cursor: 'pointer'}}>
                    <span
                        className={`nav-link ${url === '/blog' ? '' : 'collapsed'}`}
                        onClick={() => handleLinkClick('/blog')}
                    >
                        <i className="bi bi-grid"/>
                        <span>Blogs</span>
                    </span>
                </li>
                <li className="nav-item" style={{cursor: 'pointer'}}>
                    <span
                        className={`nav-link ${url === '/create-new-hackathon' ? '' : 'collapsed'}`}
                        onClick={() => handleLinkClick('/create-new-hackathon')}
                    >
                        <i className="bi bi-grid"/>
                        <span>Create New Hackathon</span>
                    </span>
                </li>
                <li className="nav-item" style={{cursor: 'pointer'}}>
                    <span
                        className={`nav-link ${url === '/hackathon' ? '' : 'collapsed'}`}
                        onClick={() => handleLinkClick('/hackathon')}
                    >
                        <i className="bi bi-grid"/>
                        <span>Hackathon</span>
                    </span>
                </li>
                <li className="nav-item" style={{cursor: 'pointer'}}>
                    <span
                        className={`nav-link ${url === '/products' ? '' : 'collapsed'}`}
                        onClick={() => handleLinkClick('/products')}
                    >
                        <i className="bi bi-grid"/>
                        <span>Products</span>
                    </span>
                </li>
                <li className="nav-item" style={{cursor: 'pointer'}}>
                    <span
                        className={`nav-link ${url === '/create-product' ? '' : 'collapsed'}`}
                        onClick={() => handleLinkClick('/create-product')}
                    >
                        <i className="bi bi-grid"/>
                        <span>Create Product</span>
                    </span>
                </li>
                <li className="nav-item" style={{cursor: 'pointer'}}>
                    <span
                        className={`nav-link ${url === '/partnership' ? '' : 'collapsed'}`}
                        onClick={() => handleLinkClick('/partnership')}
                    >
                        <i className="bi bi-grid"/>
                        <span>Partnership</span>
                    </span>
                </li>
                <li className="nav-item" style={{cursor: 'pointer'}}>
                    <span
                        className={`nav-link ${url === '/sponsorship' ? '' : 'collapsed'}`}
                        onClick={() => handleLinkClick('/sponsorship')}
                    >
                        <i className="bi bi-grid"/>
                        <span>Sponsorship</span>
                    </span>
                </li>
                <li className="nav-item" style={{cursor: 'pointer'}}>
                    <span
                        className={`nav-link ${url === '/apply-as-judges' ? '' : 'collapsed'}`}
                        onClick={() => handleLinkClick('/apply-as-judges')}
                    >
                        <i className="bi bi-grid"/>
                        <span>Apply For Judges</span>
                    </span>
                </li>
                <li className="nav-item" style={{cursor: 'pointer'}}>
                    <span
                        className={`nav-link ${url === '/registration' ? '' : 'collapsed'}`}
                        onClick={() => handleLinkClick('/registration')}
                    >
                        <i className="bi bi-grid"/>
                        <span>Registration</span>
                    </span>
                </li>
                <li className="nav-item" style={{cursor: 'pointer'}}>
                    <span
                        className={`nav-link ${url === '/team-caption' ? '' : 'collapsed'}`}
                        onClick={() => handleLinkClick('/team-caption')}
                    >
                        <i className="bi bi-grid"/>
                        <span>Team Caption</span>
                    </span>
                </li>
            </ul>
        </aside>
    );
};

export default Sidebar;
